__turbopack_context__.v({
  "footerCopyright": "SecondaryFooter-module-scss-module__thjaYq__footerCopyright",
  "footerHiddenAccessible": "SecondaryFooter-module-scss-module__thjaYq__footerHiddenAccessible",
  "footerLinksContainer": "SecondaryFooter-module-scss-module__thjaYq__footerLinksContainer",
  "footerLogo": "SecondaryFooter-module-scss-module__thjaYq__footerLogo",
  "secondaryFooter": "SecondaryFooter-module-scss-module__thjaYq__secondaryFooter",
});
